import { keepPreviousData, useQuery } from '@tanstack/react-query';
import type { TrackerImagesQuery } from '@pms/shared';
import { trackingService } from '@/services/tracking.service';
import { retryUnlessSetupError, trackerKeys } from './trackerQuery';

export function useTrackerImages(query: Partial<TrackerImagesQuery>) {
  return useQuery({
    queryKey: [...trackerKeys.images, query],
    queryFn: () => trackingService.images(query),
    // Keep the current page on screen while the next one loads.
    placeholderData: keepPreviousData,
    retry: retryUnlessSetupError,
  });
}
